import React from 'react';
import { Page } from '../components/ui/Page';
import { Card } from '../components/ui/Card';
import { Kicker } from '../components/ui/Kicker';
import { TERMS_SECTIONS } from './termsContent';

const TermsPage: React.FC = () => (
  <Page width="narrow">
    <Kicker>Legal</Kicker>
    <h1 className="page-title" style={{ marginTop: 8 }}>Terms of Service</h1>
    <p className="muted" style={{ marginTop: 4 }}>Last updated June 10, 2023</p>

    <Card style={{ marginTop: 20, padding: 32, lineHeight: 1.7, fontSize: 15, color: 'var(--ink-2)' }}>
      {TERMS_SECTIONS.map((section, i) => (
        <div key={section.id} style={{ marginTop: i ? 28 : 0 }}>
          <h3 style={{ color: 'var(--ink)', marginBottom: 10, fontSize: 16 }}>{section.title}</h3>
          {section.content.map((para, j) => (
            <p key={j} style={{ marginTop: j ? 10 : 0 }}>{para}</p>
          ))}
          {section.bullets && section.bullets.length > 0 && (
            <ul style={{ marginTop: 10, paddingLeft: 20 }}>
              {section.bullets.map((b, k) => (
                <li key={k} style={{ marginTop: 4 }}>{b}</li>
              ))}
            </ul>
          )}
          {section.subsections?.map((sub, m) => (
            <div key={m} style={{ marginTop: 10 }}>
              {sub.heading && (
                <strong style={{ color: 'var(--ink)', display: 'block', marginBottom: 4 }}>
                  {sub.heading}
                </strong>
              )}
              <p>{sub.body}</p>
            </div>
          ))}
        </div>
      ))}
    </Card>
  </Page>
);

export default TermsPage;
